import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Grid, Link } from '@raskrask-dk/rr-components'
import { ReactElement, useMemo } from 'react'
import { CodeInputSwitchProps } from './props'
import { StyledCode, StyledCodeField, StyledCodes } from './styles'
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'

export const CodeInputSwitch = <ButtonOption extends string | undefined>({
    switchHandler,
    helpLinkHandler,
}: CodeInputSwitchProps<ButtonOption>): ReactElement => {
    const {
        buttonHandlers,
        selectedOption,
        onClickButton,
        setShowCantUseFormError,
        canUseForm,
    } = switchHandler
    const { shouldShowHelpLink, href, linkText } = helpLinkHandler

    const Child = useMemo(() => {
        const comp = buttonHandlers.find(
            (bh) => bh.value === selectedOption
        )?.child
        return comp ? <StyledCodeField>{comp}</StyledCodeField> : <></>
    }, [buttonHandlers, selectedOption])

    return (
        <>
            <StyledCodes>
                <>
                    {buttonHandlers.map(
                        ({ buttonText, value, dataCy, isDisabled }) => (
                            <StyledCode
                                active={selectedOption === value}
                                key={value}
                                disabled={isDisabled}
                            >
                                <Button
                                    css={{ p: '$2' }}
                                    data-cy={dataCy}
                                    onClick={() => {
                                        if (canUseForm) {
                                            onClickButton(value)
                                        } else {
                                            setShowCantUseFormError(true)
                                        }
                                    }}
                                    size="large"
                                >
                                    <FontAwesomeIcon icon={faCircleXmark} />
                                    {buttonText}
                                </Button>
                            </StyledCode>
                        )
                    )}
                </>
            </StyledCodes>
            <Grid>
                {Child}
                {shouldShowHelpLink && (
                    <Link target={'_blank'} href={href}>
                        {linkText}
                    </Link>
                )}
            </Grid>
        </>
    )
}
